




















import { Component, Vue } from "vue-property-decorator";
import * as reportService from '@/services/report';
import { cpf } from 'cpf-cnpj-validator';
import { CNPJ } from '@/utils/cnpj';
import { BSpinner } from 'bootstrap-vue';


@Component({
  name: "DocToCarReport",
  components: {
    BSpinner,
  },
})
export default class DocToCarReport extends Vue {
  
  private docValue: string = '';

  private wrongMessage = false;

  private cpfInvalid: string[] = [];
  private cnpjInvalid: string[] = [];
  private docInvalid: string[] = [];

  private isDownloadingReport = false;

  private get documents() {
    const onlyNum = this.docValue.replace(/\.|-|\//gm, '');
    const delimiter = /(?:,| |\.|;|\n|\t|\r)+/;
    return onlyNum.split(delimiter).filter(n => !!n).map(d => d.toUpperCase());
  }

  private async docValidate() {
    this.cpfInvalid = [];
    this.cnpjInvalid = [];
    this.docInvalid = [];
    this.wrongMessage = false;

    for (const doc of this.documents) {
      if (doc.length === 11 && !cpf.isValid(doc)) {
        this.cpfInvalid.push(doc);
        this.wrongMessage = true;
      } else if (doc.length === 14 && !CNPJ.isValid(doc)) {
        this.cnpjInvalid.push(doc);
        this.wrongMessage = true;
      } else if (doc.length !== 11 && doc.length !== 14) {
        this.docInvalid.push(doc);
        this.wrongMessage = true;
      }
    }

    if (!this.wrongMessage && this.documents.length > 0) {
      await this.requestDocumentToCarReport();
    }
  }

  private wrongMessageFormatted() {
    let cpfFormatted = '';
    let cnpjFormatted = '';
    let docFormatted = '';

    const joined = (arr: string[]) => arr.join('; ');

    if (this.cpfInvalid.length === 1) {
      cpfFormatted = `CPF inválido: ${joined(this.cpfInvalid)}; `;
    } else if (this.cpfInvalid.length > 1) {
      cpfFormatted = `CPFs inválidos: ${joined(this.cpfInvalid)}; `;
    }

    if (this.cnpjInvalid.length === 1) {
      cnpjFormatted = `CNPJ inválido: ${joined(this.cnpjInvalid)}; `;
    } else if (this.cnpjInvalid.length > 1) {
      cnpjFormatted = `CNPJs inválidos: ${joined(this.cnpjInvalid)}; `;
    }

    if (this.docInvalid.length === 1) {
      docFormatted = `A quantidade de números deste documento está incorreta: ${joined(this.docInvalid)}; `;
    } else if (this.docInvalid.length > 1) {
      docFormatted = `As quantidades de números destes documentos estão incorretas: ${joined(this.docInvalid)}; `;
    }

    return cpfFormatted + cnpjFormatted + docFormatted;
  }

  private resetDocValidation() {
    this.docValue = '';
    this.cpfInvalid = []
    this.cnpjInvalid = []
    this.docInvalid = []
    this.wrongMessage = false;
  }

  private async requestDocumentToCarReport() {
    const request = this.documents;

    this.isDownloadingReport = true;
    try {
      await reportService.downloadDocToCarReport(request);
    } finally {
      this.isDownloadingReport = false;
    }
  }
}
